import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import EnrollmentReportActions, { EnrollmentReportRedux, EnrollmentReportTypes } from '../Redux/EnrollmentReportRedux'
import { notificationFail } from '../Redux/NotificationActions'

const EnrollmentReportCRUDObservable = createCRUDObservable({
  mainRedux: EnrollmentReportRedux,
  reduxPath: 'enrollmentreport',
})

const enrollmentsEpic = (action$, store, { Api }) =>
  action$.ofType(EnrollmentReportTypes.EnrollmentReportRequest)
    .mergeMap(({ start_date, end_date }) => (
      Observable
        .fromPromise(Api.enrollmentreport.getEnrollmentReportExcel(start_date, end_date)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              EnrollmentReportActions.EnrollmentReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            EnrollmentReportActions.EnrollmentReportSuccess(data, fileName),
          ]
        })
    ))

const centersEnrollmentsEpic = (action$, store, { Api }) =>
  action$.ofType(EnrollmentReportTypes.CentersEnrollmentReportRequest)
    .mergeMap(({ start_date, end_date, centerId }) => (
      Observable
        .fromPromise(Api.enrollmentreport.getCentersEnrollmentReportExcel(start_date, end_date, centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              EnrollmentReportActions.CentersEnrollmentReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            EnrollmentReportActions.CentersEnrollmentReportSuccess(data, fileName),
          ]
        })
    ))

export const EnrollmentReportObservers = Object.assign({}, EnrollmentReportCRUDObservable.observers, {})
export const enrollmentreportEpic = combineEpics(
  EnrollmentReportCRUDObservable.epic,
  enrollmentsEpic,
  centersEnrollmentsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/EnrollmentReportObservable.js